import HeroSmartphone from 'shared/lib/assets/img/landing/hero-smartphone.png';
import LogoWarrantech from 'shared/lib/assets/img/logo/logo-warrantech.svg';

export const smartphoneConfig = {
  hero: {
    heading: 'Dialed up protection for your smartphone',
    subheading:
      'You had a smashing good time—but so did your phone. Broken glass has no place in your pocket, so SURE makes protection easy and affordable, covering phones even up to two years old.',
    cta: 'Get smartphone insurance',
    ctaLink: '/',
    img: HeroSmartphone,
  },
  underwriter: {
    img: LogoWarrantech,
    name: 'Warrantech',
  },
  coverageDetails: [
    {
      heading: 'Cracked Screens + Physical Damage',
      subheading:
        'Tap, swipe… slip. Cracked screens are common, and they’re covered—and so is other physical phone damage that comes along with a busy life.',
    },
    {
      heading: 'Dust + Overheating',
      subheading:
        'Overheating can burn up your phone’s internal wiring, and dust can sneak through jacks and portals to wreak havoc. Either way, you’re covered.',
    },
    {
      heading: 'Water Damage',
      subheading:
        'Did your phone do the high dive from your back pocket into the toilet? Save the rice bath and get it repaired the same day, ‘cause you’re covered.',
    },
  ],
  scenarioDetails: {
    heading: 'Why Would You Need Smartphone Insurance?',
    scenarios: [
      {
        heading: 'Scenario 1',
        subheading:
          'Your sweet toddler took it upon himself to clean your phone—in the tub.',
      },
      {
        heading: 'Scenario 2',
        subheading:
          'You’re a busy bee, and that means using your phone to the max -- and a weakened battery that now needs to be replaced (so you can get back to busy).',
      },
      {
        heading: 'Scenario 3',
        subheading:
          'Texting-while-walking leads to a trip down the sidewalk—and a cracked screen on your phone.',
      },
    ],
  },
  comparison: [
    'Instant quote',
    'Buy and manage your policy in one place',
    'Insurance explained in simple, easy-to-digest way',
    'Mobile',
    'Endorsements',
    'Plan tailored to fit your needs',
  ],
};
